// ── imports explicites (Phase 4B, générés puis maintenus à la main) ──
import { deleteFromR2, r2KeyFromUrl } from "./06-images-upload.jsx";
const supabaseConfig=()=>({
  url:(window.LANAC_SUPABASE_URL||localStorage.getItem("lanac:supabase:url")||"").trim(),
  anonKey:(window.LANAC_SUPABASE_ANON_KEY||localStorage.getItem("lanac:supabase:anonKey")||"").trim()
});
// ── IDENTITÉ DU CLIENT (Capacitor, phase 0, 11/09/2026) ──────────────────────────────────────────
//  Chaque requête du client Supabase dit QUI appelle : le build servi (identité de CONTENU de dist/,
//  build.mjs §9), le niveau natif de la coque et la plateforme. La sonde existe déjà : les journaux
//  Supabase enregistrent x-client-info (tools/sonde-versions-clients.sql) ⇒ « qui tourne quoi, depuis
//  quand », sans une requête ni un octet d'egress de plus — la condition pour ne jamais retirer un
//  contrat serveur qu'un client encore en circulation lit (PLAN-CAPACITOR, P6).
//  ⭐ ON AJOUTE, ON NE REMPLACE PAS : le jeton de la bibliothèque (« supabase-js/x.y.z; runtime=web »)
//   reste EN TÊTE, dans sa grammaire (« ; clé=valeur ») ; nos clés sont préfixées lanac- (aucune
//   collision possible avec une clé future de supabase-js).
//  ⭐ ZÉRO RISQUE CORS : x-client-info est DÉJÀ envoyé, donc déjà autorisé par chaque préflight ; seule
//   sa VALEUR change. Un en-tête NEUF aurait exigé une autorisation CORS de plus — refusée, c'étaient
//   TOUTES les requêtes en échec. On n'ajoute donc jamais d'en-tête : on prolonge celui qui existe.
//  ⭐ INFAILLIBLE PAR CONSTRUCTION : la moindre anomalie rend l'init INCHANGÉ — la requête part comme avant.
//  P1 : lanacShell() est la SEULE fonction à changer (détection de la coque native).
const lanacShell=()=>({platform:"web",native:0});
const lanacBuildId=()=>{
  try{const v=document.querySelector('meta[name="lanac-build"]')?.getAttribute("content")||"";return /^[0-9a-f]{12}$/.test(v)?v:"dev";}
  catch(e){return "dev";}
};
const lanacClientTag=()=>{const s=lanacShell();return `lanac-build=${lanacBuildId()}; lanac-native=${s.native}; lanac-platform=${s.platform}`;};
const withClientTag=(init,tag)=>{
  try{
    if(!init||!init.headers) return init;
    const headers=new Headers(init.headers);
    const info=headers.get("x-client-info");
    if(!info||info.includes("lanac-build=")) return init;
    headers.set("x-client-info",`${info}; ${tag}`);
    return {...init,headers};
  }catch(e){return init;}
};
// ── UN COMPTE SUPPRIMÉ N'AGIT PLUS — le côté écran (C7 · T17, 17/09/2026) ────────────────────────
//  La base refuse désormais tout geste d'un compte dont le profil a disparu, et elle le NOMME
//  (`account_deleted`, P0001 → 400). Or un compte supprimé peut garder un jeton valide AILLEURS :
//  un autre appareil, un onglet resté ouvert — au plus une heure, le temps d'un jeton. Une seule
//  porte, ici, sur la RÉPONSE : au premier refus nommé, on purge la session LOCALE et on recharge,
//  comme le coup de grâce d'un compte suspendu (30/08). Aucune requête de plus, aucun écran qui
//  décide, et le corps n'est lu QUE sur un 400 (sur un clone : la réponse rendue reste intacte).
const __lncGoneWatch=res=>{
  try{
    if(!res||res.status!==400||window.__lncGoneDone) return res;
    res.clone().text().then(t=>{
      if(window.__lncGoneDone||!t||String(t).replace(/\s+/g,"").indexOf('"message":"account_deleted"')<0) return;
      window.__lncGoneDone=true;
      const c=window.__lanacSupabaseClient;
      Promise.resolve(c&&c.auth?lanacSortie({scope:"local"}):null).catch(()=>{}).then(()=>{try{window.location.reload();}catch(_){}});
    },()=>{});
  }catch(e){}
  return res;
};
const lanacSupabaseClient=()=>{
  const cfg=supabaseConfig();
  if(!cfg.url||!cfg.anonKey||!window.supabase?.createClient) return null;
  const patchQuery=query=>{
    if(!query||typeof query!=="object") return query;
    if(typeof query.then==="function"&&typeof query.catch!=="function") query.catch=function(onRejected){return this.then(undefined,onRejected);};
    ["select","insert","upsert","update","delete","eq","neq","gt","gte","lt","lte","is","in","contains","containedBy","rangeGt","rangeGte","rangeLt","rangeLte","textSearch","match","not","or","filter","order","limit","range","abortSignal","single","maybeSingle","csv","geojson","explain","rollback","returns"].forEach(method=>{
      if(typeof query[method]!=="function"||query[method].__lanacPatched) return;
      const original=query[method];
      query[method]=function(...args){return patchQuery(original.apply(this,args));};
      query[method].__lanacPatched=true;
    });
    return query;
  };
  if(!window.__lanacSupabaseClient){
    // P0 sonde EGRESS (local-first sync-core) — LANAC_DEBUG UNIQUEMENT, INERTE en prod : mesure les octets
    //  de RÉPONSE data/rpc Supabase pour établir la baseline egress et prouver `after ≤ before` aux phases
    //  suivantes. Sécurité : bucketise par PATHNAME seul (jamais les query params → aucun id/PII capturé) ;
    //  ne consomme PAS le corps (res.clone()) ; erreurs avalées (ne peut pas casser une requête). Quand debug
    //  OFF, pas de sonde : le seul `global.fetch` est celui de l'identité du client (ci-dessous), qui ne
    //  change QUE la valeur de x-client-info — le reste du comportement est celui d'avant la phase 0.
    const __lncEgressDbg=(()=>{try{return localStorage.getItem("lanac:debug")==="1";}catch(e){return false;}})();
    const __lncEgressFetch=__lncEgressDbg?((input,init)=>fetch(input,init).then(res=>{
      try{
        const store=(window.__lncEgress=window.__lncEgress||{bytes:0,requests:0,byPath:{}});
        res.clone().arrayBuffer().then(buf=>{
          store.bytes+=buf.byteLength;store.requests+=1;
          let path="?";try{path=new URL((input&&input.url)||input,location.href).pathname;}catch(e){}
          store.byPath[path]=(store.byPath[path]||0)+buf.byteLength;
        }).catch(()=>{});
      }catch(e){}
      return res;
    })):null;
    //  IDENTITÉ DU CLIENT (Capacitor, phase 0) : le fetch du client passe TOUJOURS par withClientTag (plus
    //  haut), qui ne fait que prolonger x-client-info. La sonde egress (debug) et l'étiquette se composent.
    const __lncTag=lanacClientTag();
    const __lncBaseFetch=__lncEgressFetch||((input,init)=>fetch(input,init));
    //  (B-HORS-LIGNE-1, 03/11/2026) un écran de membre ne lit jamais en anonyme : voir lanacSansJetonRefus, plus bas.
    const client=window.supabase.createClient(cfg.url,cfg.anonKey,{auth:{persistSession:true,autoRefreshToken:true,detectSessionInUrl:true},global:{fetch:(input,init)=>lanacSansJetonRefus(input,init,cfg.anonKey)||__lncBaseFetch(input,withClientTag(init,__lncTag)).then(__lncGoneWatch)}});
    const originalFrom=client.from.bind(client);
    client.from=(...args)=>patchQuery(originalFrom(...args));
    window.__lanacSupabaseClient=client;
  }
  return window.__lanacSupabaseClient;
};
// ── LA CARTE DU MEMBRE (B-HORS-LIGNE-1, 03/11/2026) ─────────────────────────────────────────────────────────────────
//  POURQUOI. Le profil du membre ne se lisait qu'au réseau, à chaque ouverture : en ligne l'accueil l'attendait (~2,6 s,
//   S188), hors ligne la lecture échouait et, au plafond (20 s), l'écran de CONNEXION s'ouvrait devant un membre connecté
//   (S189) — tout de suite après l'expiration du jeton (1 h) : supabase-js rend alors `{session:null, error}`, la session
//   restant rangée. Les grandes applications (Instagram, Twitter Lite, Slack, WhatsApp Web) montrent ce qu'elles ont et
//   vérifient derrière : ici, une CARTE du membre, écrite après chaque profil FRAIS, lue à l'ouverture (`provisoire`), puis
//   REMPLACÉE par la lecture qui part en fond, comme avant (même requête, même coût).
//  ⭐ LA CARTE NE DONNE AUCUN DROIT : la base reste seule juge (RLS, commandes) ; updateMe, la page profil et la file des
//   publications attendent le frais. Elle ne garde que ce que l'annuaire local (`lanac:users`) tenait déjà du membre.
//  ⭐ ELLE NE VIT QU'AVEC SA SESSION : lue seulement si le jeton RANGÉ (avec refresh_token) est celui du même membre, de la
//   forme v1, de moins de 30 jours ; jamais réécrite depuis une carte, jamais pour un compte non vérifié (SIGNED_OUT y est
//   ignoré) ni pour un profil sans ligne (compte supprimé) ; oubliée à chaque sortie, AVANT d'attendre la bibliothèque.
//  ⭐ L'ÉPOQUE : chaque oubli l'avance — une restauration partie avant une sortie et revenue après est jetée.
//  ⭐ SANS JETON (hors ligne, jeton expiré), le client retombe sur la clé ANONYME : RLS rendrait du VIDE qui écraserait les
//   caches du membre. Tant que `window.__lncSansJeton` est posé, une requête de données à la clé anonyme part en échec
//   réseau — exactement comme hors ligne ; le rafraîchissement du jeton (/auth) passe toujours.
//  Banc : tests/la-carte-du-membre.test.mjs (ce bloc y est EXÉCUTÉ tel quel).
const LNC_CARTE_CLE="lanac:carte:v1";
const LNC_CARTE_AGE_MAX_MS=30*24*3600*1000;
const LNC_CARTE_CHAMPS=["id","name","email","phone","avatar","country","city","cityLat","cityLng","color","role","verified","emailVerified","phoneVerified",
  "blocked","isAdmin","authProvider","applePrivateRelay","acceptsOffers","publishBurstBypass","profileIncomplete","notifPush","notifEmail","notifInApp",
  "notifPrefs","cookies","createdAt","supabaseUserId","trustScore","trustBoost","trustBreakdown","isTrusted","salesCount","tier","boostTier",
  "followerCount","followingCount","ratingCount","ratingAvg","pendingVerification","pendingEmail","termsAccepted","welcomeCompleted"];
const LNC_CARTE_OBJETS=["notifPrefs","trustBreakdown"];
let lanacEpoque=0;
const lanacEpoqueSession=()=>lanacEpoque;
const carteNettoyee=me=>{
  const o={};
  for(const k of LNC_CARTE_CHAMPS){
    const v=me[k], t=typeof v;
    if(v===null||t==="string"||t==="boolean"||(t==="number"&&Number.isFinite(v))) o[k]=v;
    else if(t==="object"&&!Array.isArray(v)&&LNC_CARTE_OBJETS.includes(k)) o[k]=JSON.parse(JSON.stringify(v));
  }
  return o;
};
const jetonRange=()=>{
  try{
    const c=lanacSupabaseClient(), k=c&&c.auth&&c.auth.storageKey;
    if(!k) return null;
    const s=JSON.parse(localStorage.getItem(k)||"null");
    const uid=s&&s.user&&s.user.id;
    if(typeof uid!=="string"||!uid||typeof s.refresh_token!=="string"||!s.refresh_token) return null;
    return {uid};
  }catch(_){return null;}
};
//  (B-ACCUEIL-1, 04/11/2026) le membre dont la session est RANGÉE sur l'appareil (lecture locale, aucune requête) — ou null. L'accueil gardé
//   le nomme : une lecture partie avant que `me` soit connu, sous SON jeton, voit ses annonces en attente ; le cache est alors à lui.
const lanacUidRange=()=>{ const j=jetonRange(); return j?j.uid:null; };
const ecrireCarte=me=>{
  try{
    if(!me||typeof me.id!=="string"||me.provisoire||me.sansLigne||!me.emailVerified||me.pendingVerification) return false;
    localStorage.setItem(LNC_CARTE_CLE,JSON.stringify({v:1,uid:me.id,at:Date.now(),me:carteNettoyee(me)}));
    return true;
  }catch(_){return false;}
};
const lireCarte=()=>{
  try{
    const j=jetonRange(); if(!j) return null;
    const c=JSON.parse(localStorage.getItem(LNC_CARTE_CLE)||"null"), maintenant=Date.now();
    if(!c||c.v!==1||c.uid!==j.uid||!c.me||c.me.id!==j.uid||!(maintenant-Number(c.at)<LNC_CARTE_AGE_MAX_MS)||Number(c.at)>maintenant+60000) return null;
    const me=carteNettoyee(c.me);
    if(typeof me.name!=="string") return null;
    return {...me,provisoire:true};
  }catch(_){return null;}
};
const oublierCarte=uid=>{
  lanacEpoque++;
  try{window.__lncSansJeton=false;}catch(_){}
  try{
    const c=JSON.parse(localStorage.getItem(LNC_CARTE_CLE)||"null");
    localStorage.removeItem(LNC_CARTE_CLE);
    const qui=uid||(c&&c.uid);
    const us=qui?JSON.parse(localStorage.getItem("lanac:users")||"null"):null;
    if(Array.isArray(us)) localStorage.setItem("lanac:users",JSON.stringify(us.filter(u=>u&&u.id!==qui)));
  }catch(_){}
  //  (B-ACCUEIL-1, 04/11/2026) L'ACCUEIL GARDÉ D'UN MEMBRE part avec lui : ses annonces (en attente ou refusées comprises, projection
  //   complète) et l'ordre de SON fil (ses centres d'intérêt) étaient peints au démarrage suivant pour la personne qui reprend l'appareil.
  //   Il est à un membre si sa mémoire d'ordre (lanac:fil:ordre, useFeedState) ou sa marque du fil (lanac:cache:home:fil) le nomme ;
  //   l'accueil d'un visiteur reste (son prochain démarrage repartirait à froid).
  try{
    const g=JSON.parse(localStorage.getItem("lanac:fil:ordre")||"null"), f=JSON.parse(localStorage.getItem("lanac:cache:home:fil")||"null");
    if((g&&typeof g.uid==="string"&&g.uid)||(f&&typeof f.uid==="string"&&f.uid)) ["lanac:cache:home","lanac:cache:home:fil","lanac:fil:ordre"].forEach(k=>localStorage.removeItem(k));
  }catch(_){}
  //  (B-DEMARRAGE-1, 04/11/2026) LES LISTES GARDÉES (lanac:aj:<liste>:<membre> — notifications, accords, signalements ; 07-trust-moderation)
  //   partent TOUTES, de tout membre : oublierCarte est aussi appelé sans uid (démarrage sans session) ; les relire coûte peu.
  try{
    const aj=[];
    for(let i=0;i<localStorage.length;i++){ const k=localStorage.key(i); if(k&&k.startsWith("lanac:aj:")) aj.push(k); }
    aj.forEach(k=>localStorage.removeItem(k));
  }catch(_){}
};
const lanacSortie=async(opts,uid)=>{
  oublierCarte(uid);
  const c=lanacSupabaseClient(); if(!c) return;
  let r=null;
  try{ r=await c.auth.signOut(opts); }catch(e){ r={error:e}; }
  //  hors ligne, jeton expiré : supabase-js rend l'erreur AVANT d'effacer la session — on l'efface ici, sinon l'ouverture
  //   suivante réinstallerait le membre qui vient de sortir
  if(r&&r.error){ try{ const k=c.auth.storageKey; [k,k+"-user",k+"-code-verifier"].forEach(x=>localStorage.removeItem(x)); }catch(_){} }
};
const lanacCarteAuDemarrage=()=>{
  try{
    if(authUrlFlow()||/[?&#](code|access_token|error|token_hash)=/.test(String(location.href||""))) return null;
    const c=lireCarte();
    //  (relecture APRÈS, D2) le garde ARMÉ dès l'ouverture sur la carte : les chargements du membre partent dans le même rendu, avant que
    //   l'effet de boot n'ait sa réponse ; une requête au jeton du MEMBRE passe toujours, et le premier jeton vu (handleAuth) le désarme
    if(c){ try{ window.__lncSansJeton=true; }catch(_){} }
    return c;
  }catch(_){return null;}
};
const lanacSansJetonRefus=(input,init,anonKey)=>{
  try{
    if(!window.__lncSansJeton) return null;
    const u=String((input&&input.url)||input||"");
    if(!/\/(rest|functions|storage)\/v1\//.test(u)) return null;
    const h=new Headers((init&&init.headers)||(input&&input.headers)||{});
    if(h.get("authorization")!=="Bearer "+anonKey) return null;
    return Promise.reject(new TypeError("Failed to fetch"));
  }catch(_){return null;}
};
// ── fin de la carte du membre ──
// ── PLAFONDS DE LONGUEUR — MIROIR DU SERVEUR (C7 · T20, 18/09/2026) ─────────────────────────────────────────
//  POURQUOI. La règle est au SERVEUR (migration `un_texte_a_une_fin`, 76 contraintes `<table>_<colonne>_len`) :
//  elle seule ne se contourne pas, et c'est elle qui décide. Ce tableau n'en est qu'un MIROIR, pour deux services
//  que le serveur ne peut pas rendre : mesurer AVANT d'envoyer (aucune requête gâchée, réponse immédiate) et
//  NOMMER le champ, pour que le site puisse en faire une phrase au lieu d'un code.
//  Il ne liste QUE les colonnes qu'un être humain remplit à la main, et QUE celles qu'une écriture de table peut
//  porter — `reports` n'y figure pas : elle s'écrit par une commande (`submit_report`), et sa zone de texte
//  s'arrête d'elle-même à 2 000 (C7 · T21). Les autres colonnes restent nommées par le SERVEUR au
//  refus : la passerelle lit alors le nom de la contrainte, et rend le même `too-long` sans plafond.
//  ⚠️ `tests/un-texte-a-une-fin.test.mjs` compare CHAQUE entrée au texte de la migration, et exige que chacune
//  désigne une contrainte qui existe : un plafond qui bougerait d'un seul côté rougit.
const LANAC_LONGUEURS={
  listings:{title:300,description:4000,city:200,address:200,brand:200,model:200,other_cat:200,other_sub_cat:200,seller_display_name:200},
  messages:{text:4000},
  reviews:{comment:2000},
  profiles:{name:200,city:200,phone:40,email:320},
  alerts:{label:300,query:200,city:200,other:200,other_sub:200,prop_type:80,brand:80,fuel:80,work_type:80},
  search_history:{label:300,query:200,city:200,other:200},
  availability_watches:{title:300},
};
//  Rend {champ, plafond, longueur} pour la PREMIÈRE colonne trop longue, sinon null. `values` peut être une ligne
//  ou un TABLEAU de lignes : une insertion groupée est refusée en bloc par la base, donc une seule ligne trop
//  longue condamne tout le lot — le site doit pouvoir le savoir avant d'envoyer.
const lanacTropLong=(table,values)=>{
  const plafonds=LANAC_LONGUEURS[table];
  if(!plafonds||!values||typeof values!=="object") return null;
  for(const ligne of (Array.isArray(values)?values:[values])){
    if(!ligne||typeof ligne!=="object") continue;
    for(const champ in plafonds){
      const v=ligne[champ];
      if(typeof v==="string"&&v.length>plafonds[champ]) return {champ,plafond:plafonds[champ],longueur:v.length};
    }
  }
  return null;
};
// ── ÉCRITURE VÉRIFIÉE — lanacWrite (C7, 13/09/2026) ─────────────────────────────────────────────────────────
//  POURQUOI. supabase-js ne rejette JAMAIS : un refus ET une coupure réseau RÉSOLVENT avec `{error}` — un
//  `.catch` posé sur une requête n'attrape rien (prouvé par exécution du bundle vendu, audit C7). Et la base sait
//  dire non SANS erreur : un UPDATE/DELETE hors politique touche 0 ligne (prouvé en production : un vendeur qui
//  supprime sa transaction → 0 ligne, aucune erreur), un déclencheur peut réécrire la ligne. Une écriture n'est
//  donc FAITE que lorsque le serveur RENVOIE les lignes qu'il a réellement écrites.
//
//  CONTRAT — lanacWrite({what, table, op, values, match, expect, columns, verify, onConflict, quiet, identity})
//    → Promise<{ok:true, rows, attempts} | {ok:false, reason, code, message, attempts}> ; ne rejette JAMAIS.
//   · op : insert · update · upsert · delete ; `match` : filtres d'égalité (update, delete) ;
//   · relit TOUJOURS les lignes touchées : `select(columns)`, "id" par défaut (quelques octets d'egress) ;
//   · expect : "one" (exactement une) · "some" (au moins une) · "any" (0 permis : `verify` juge) ;
//   · reason : offline (coupure) · refused (non, avec erreur) · no-effect (non SANS erreur : 0 ligne) ·
//     ambiguous (plusieurs lignes pour "one") · rewritten (`verify` refuse ce qui a été relu) ·
//     rate-limited (C7 · T25 : le serveur a refusé pour CADENCE — porte `phrase` et `secondes`) ·
//     out-of-range (C7 · T25 : une borne NUMÉRIQUE de T24 — porte `champ`) ·
//     duplicate (23505, et la ligne n'est pas la nôtre) · too-long (C7 · T20 : un texte au-delà de son plafond —
//     rendu AVANT l'envoi quand la colonne est au miroir `LANAC_LONGUEURS` (aucune requête), ou au retour d'un
//     23514 dont le nom de contrainte finit par `_len` ; porte `champ`, `plafond` (null si hors miroir) et
//     `longueur`, pour que le site en fasse une phrase) · exception · no-client ;
//   · RÉESSAIE ce qui peut guérir, et seulement ça : coupure, 408, 429, 5xx — deux fois (0,8 s puis 2,5 s) ; la
//     requête DOIT donc être idempotente (un id, un filtre exact). 42501 : session revue, puis UN réessai (le
//     patron de persistMessageUpdate) ;
//   · 23505 sur un insert qui porte son identité (`identity` : ["id"] par défaut, ou une clé COMPOSÉE comme
//     ["user_id","listing_id"]) : on RELIT cette ligne — présente, l'état voulu est tenu (réponse perdue, ou ligne
//     déjà là : succès) ; absente, la place est prise (duplicate). ⚠️ Une table SANS colonne `id` nomme aussi ses
//     `columns` : la relecture par défaut demanderait `id` (42703 — la veille, mesuré en production) ;
//   · un échec final est DIT : console + observabilité (write_failed), sans aucune valeur écrite. Sans client
//     (mode local), rien n'est dit : il n'y a rien à rapporter. `quiet` : les issues que le SITE attend (ex.
//     ["duplicate"] pour une course prévue par la conception) sont rendues, mais ni rapportées ni écrites.
//  Garde : tools/supabase-write-guard.mjs (R0) — une écriture NEUVE passe par ici. Banc : tests/lanac-write.test.mjs.
const LANAC_WRITE_RETRY_MS=[800,2500];
/**
 * Le descripteur d'une écriture — le CONTRAT ci-dessus, lisible par tsc pour les fichiers qui s'y soumettent (// @ts-check).
 * @typedef {{what?:string, table:string, op:"insert"|"update"|"upsert"|"delete", values?:any, match?:Object<string,any>,
 *   expect?:"one"|"some"|"any", columns?:string, verify?:(rows:any[])=>boolean, onConflict?:string, quiet?:string[],
 *   identity?:string[]}} LanacEcriture
 */
/** @type {(d:LanacEcriture)=>Promise<any>} */
const lanacWrite=async({what="",table,op,values,match,expect="one",columns="id",verify,onConflict,quiet=[],identity=["id"]}={})=>{
  const label=what||`${table}.${op}`;
  const echec=(reason,err,attempts,silencieux=false)=>{
    const r={ok:false,reason,code:err?.code||null,message:err?.message||null,attempts};
    if(!silencieux&&!(Array.isArray(quiet)&&quiet.includes(reason))){
      try{console.error("[LANAC] write failed:",label,reason,r.code||"",r.message||"");}catch(_){}
      try{window.__lncReport?.("write_failed",`${label} · ${table}.${op} · ${reason}${r.code?" · "+r.code:""}`);}catch(_){}
    }
    return r;
  };
  const client=lanacSupabaseClient();
  if(!client) return echec("no-client",null,0,true);
  if(!table||!["insert","update","upsert","delete"].includes(op)) return echec("exception",{message:"descripteur d'écriture invalide"},0);
  //  T20 : mesurer AVANT d'envoyer. La base refuserait (23514) ; autant ne pas faire le voyage, et NOMMER le champ.
  if(op!=="delete"){
    const trop=lanacTropLong(table,values);
    if(trop) return {...echec("too-long",{code:"23514",message:`${table}.${trop.champ} : ${trop.longueur} caractères (plafond ${trop.plafond})`},0),...trop,regle:`${table}_${trop.champ}_len`};
  }
  const construire=()=>{
    const base=client.from(table);
    let q=op==="insert"?base.insert(values):op==="upsert"?base.upsert(values,onConflict?{onConflict}:undefined):op==="update"?base.update(values):base.delete();
    for(const [k,v] of Object.entries(match||{})) q=q.eq(k,v);
    return q.select(columns);
  };
  const juger=(rows,attempts)=>{
    if((expect==="one"||expect==="some")&&rows.length===0) return echec("no-effect",null,attempts);
    if(expect==="one"&&rows.length>1) return echec("ambiguous",null,attempts);
    if(typeof verify==="function"){let bon=false;try{bon=!!verify(rows);}catch(_){bon=false;}if(!bon) return echec("rewritten",null,attempts);}
    return {ok:true,rows,attempts};
  };
  let attempts=0,sessionRevue=false,reprises=0;
  for(;;){
    attempts++;
    let res;
    try{res=await Promise.resolve(construire());}catch(e){return echec("exception",e,attempts);}
    const err=res?.error;
    if(!err) return juger(Array.isArray(res?.data)?res.data:(res?.data?[res.data]:[]),attempts);
    if(err.code==="42501"&&!sessionRevue){
      sessionRevue=true;
      let session=false;
      try{const {data}=await client.auth.getSession();session=!!data?.session;}catch(_){}
      if(session) continue;
    }
    const cles=Array.isArray(identity)&&identity.length?identity:["id"];
    if(err.code==="23505"&&op==="insert"&&values&&cles.every(k=>values[k]!=null)){
      let relue=null;
      try{let q2=client.from(table).select(columns);for(const k of cles) q2=q2.eq(k,values[k]);const r2=await Promise.resolve(q2);if(!r2?.error&&Array.isArray(r2?.data)) relue=r2.data;}catch(_){}
      if(relue&&relue.length) return juger(relue,attempts);
      return echec("duplicate",err,attempts);
    }
    //  T20 : le serveur a nommé sa règle (`<table>_<colonne>_len`). On la rend telle quelle : le miroir ne liste
    //   que ce qu'un humain tape, et une colonne hors miroir doit quand même donner un `too-long`, sans plafond.
    if(err.code==="23514"){
      const m=/constraint "([a-z0-9_]+_len)"/.exec(String(err.message||""));
      if(m){
        const regle=m[1];
        const champ=regle.startsWith(table+"_")?regle.slice(table.length+1,-4):null;
        const plafond=(champ&&LANAC_LONGUEURS[table]&&LANAC_LONGUEURS[table][champ])||null;
        return {...echec("too-long",err,attempts),regle,champ,plafond,longueur:null};
      }
      //  T25 : les bornes NUMÉRIQUES de T24 se nomment `_max` (un plafond ajouté sous un plancher existant) ou
      //   `_bornes` (les deux côtés posés d'un coup). Sans cette lecture elles tombaient dans le `refused`
      //   générique — un refus que l'écran ne sait pas raconter, c'est-à-dire, selon T20, un refus avalé.
      const mb=/constraint "([a-z0-9_]+_(?:max|bornes))"/.exec(String(err.message||""));
      if(mb){
        const regle=mb[1];
        const champ=regle.startsWith(table+"_")?regle.slice(table.length+1).replace(/_(?:max|bornes)$/,""):null;
        return {...echec("out-of-range",err,attempts),regle,champ};
      }
    }
    //  ⭐ T25 · LA CADENCE. Le serveur refuse en 42910, met sa PHRASE dans `hint` et — c'est ce qui change tout —
    //   le nombre de SECONDES à attendre dans `details`. L'écran peut donc afficher un compte à rebours et
    //   n'envoyer AUCUNE requête d'ici là : zéro octet pour une tentative qui serait refusée. Un refus qui ne
    //   dit pas QUAND réessayer condamne à retenter au hasard, et chaque essai se paie.
    //  ⚠️ On lit la FAMILLE `429xx`, pas le seul 42910 : c'est déjà le prédicat de `lanacRpc` (qui traduit
    //   ainsi les refus des signalements), et c'est aussi le code que T23 emploie pour ses plafonds de volume.
    //   L'écran n'a pas à savoir LEQUEL il a rencontré : il montre la phrase que le serveur a écrite.
    if(/^429[0-9A-Z]{2}$/.test(String(err.code||""))){
      const brut=String(err.details??"").trim();
      const secondes=/^[0-9]+$/.test(brut)?Number(brut):null;
      return {...echec("rate-limited",err,attempts),phrase:String(err.hint||"")||null,secondes};
    }
    const status=Number(res?.status)||0;
    if((status===0||status===408||status===429||status>=500)&&reprises<LANAC_WRITE_RETRY_MS.length){
      await new Promise(r=>setTimeout(r,LANAC_WRITE_RETRY_MS[reprises++]));
      continue;
    }
    return echec(status===0?"offline":"refused",err,attempts);
  }
};
// ── COMMANDE VÉRIFIÉE — lanacRpc (C7 · reports T1, 13/09/2026) ──────────────────────────────────────────────────
//  POURQUOI. Une commande serveur (submit_report, report_incident, moderate_report…) dit OUI en rendant sa réponse,
//  et NON par une erreur NOMMÉE : le message EST le nom du refus (report_self_accusation, incidents_are_not_judged…).
//  supabase-js résout l'un comme l'autre avec `{data, error}` — et une coupure réseau aussi. Et PostgREST habille
//  certains refus en 5xx (55000 « l'état a changé » → HTTP 500) : réessayer « tout 5xx » rejouerait un refus.
//
//  CONTRAT — lanacRpc({what, name, args, idempotent, verify, quiet})
//    → Promise<{ok:true, data, attempts} | {ok:false, reason, code, refusal, message, hint, attempts}> ; ne rejette JAMAIS.
//   · reason : offline (coupure) · unavailable (panne serveur qui ne guérit pas) · refused (refus : son nom dans
//     `refusal`) · conflict (55000 : l'état a changé entre la lecture et la décision) · rate-limited (429xx) ·
//     invalid (22023, 22P02) · unauthenticated (28000, HTTP 401) · rewritten (`verify` refuse la réponse) ·
//     exception · no-client ;
//   · RÉESSAIE la coupure, le 408, le 429 sans SQLSTATE et le 5xx sans SQLSTATE ou transitoire (08…, 53…, 57014,
//     57P0…, 40001, 40P01) — deux fois (0,8 s puis 2,5 s) — et SEULEMENT si `idempotent` : la commande porte
//     l'identifiant de son effet, la rejouer ne le double pas. Une commande non idempotente n'est jamais rejouée ;
//   · « permission denied for function » (jeton expiré en route) : session revue, puis UN réessai si idempotent ;
//   · un échec final est DIT (console + observabilité rpc_failed, jamais les arguments), sauf ce que `quiet` nomme —
//     une issue (["conflict"]) ou un refus (["report_rate_limited"]) que le site sait raconter.
//  Banc : tests/lanac-rpc.test.mjs.
const LANAC_RPC_TRANSITOIRE=/^(08|53|57014|57P0|40001|40P01)/;
const lanacRpc=async({what="",name,args,idempotent=false,verify,quiet=[]}={})=>{
  const label=what||name||"rpc";
  const echec=(reason,err,attempts,silencieux=false)=>{
    const message=err?.message||null;
    const refusal=message&&/^[a-z][a-z0-9_]{2,80}$/.test(message)?message:null;
    const r={ok:false,reason,code:err?.code||null,refusal,message,hint:err?.hint||null,attempts};
    const tait=Array.isArray(quiet)&&(quiet.includes(reason)||(!!refusal&&quiet.includes(refusal)));
    if(!silencieux&&!tait){
      try{console.error("[LANAC] rpc failed:",label,reason,r.code||"",refusal||"");}catch(_){}
      try{window.__lncReport?.("rpc_failed",`${label} · ${name} · ${reason}${r.code?" · "+r.code:""}${refusal?" · "+refusal:""}`);}catch(_){}
    }
    return r;
  };
  const client=lanacSupabaseClient();
  if(!client) return echec("no-client",null,0,true);
  if(typeof name!=="string"||!/^[a-z][a-z0-9_]*$/.test(name)) return echec("exception",{message:"commande invalide"},0);
  let attempts=0,sessionRevue=false,reprises=0;
  for(;;){
    attempts++;
    let res;
    try{res=await Promise.resolve(args===undefined?client.rpc(name):client.rpc(name,args));}catch(e){return echec("exception",e,attempts);}
    const err=res?.error;
    if(!err){
      if(typeof verify==="function"){let bon=false;try{bon=!!verify(res.data);}catch(_){bon=false;}if(!bon) return echec("rewritten",null,attempts);}
      return {ok:true,data:res.data,attempts};
    }
    const status=Number(res?.status)||0,code=String(err.code||"");
    if(idempotent&&!sessionRevue&&code==="42501"&&/permission denied for function/i.test(err.message||"")){
      sessionRevue=true;
      let session=false;
      try{const {data}=await client.auth.getSession();session=!!data?.session;}catch(_){}
      if(session) continue;
    }
    const sqlstate=/^[0-9A-Z]{5}$/.test(code);
    const transitoire=status===0||status===408||(status===429&&!sqlstate)||(status>=500&&(!sqlstate||LANAC_RPC_TRANSITOIRE.test(code)));
    if(transitoire&&idempotent&&reprises<LANAC_WRITE_RETRY_MS.length){
      await new Promise(r=>setTimeout(r,LANAC_WRITE_RETRY_MS[reprises++]));
      continue;
    }
    const reason=status===0?"offline"
      :code==="55000"?"conflict"
      :/^429\d\d$/.test(code)?"rate-limited"
      :(code==="22023"||code==="22P02")?"invalid"
      :(code==="28000"||status===401)?"unauthenticated"
      :transitoire?"unavailable"
      :"refused";
    return echec(reason,err,attempts);
  }
};
//  ── LA COMMANDE DES BOUTONS DE STATUT (revue du 24/09/2026, lot 3b) ──────────────────────────────────────────────────
//  set_listing_status : la liste que l'écran propose (statusOptionsForActor), tenue par la base (listing_transitions). OUI =
//   {status, changed} ; NON = un refus NOMMÉ (listing_not_yours, listing_closed, status_internal, status_not_offered,
//   reservation_held) que l'écran dit (listingStatusRefusalKey). Idempotente : le même statut deux fois ne change rien.
//  24/09/2026 (vendu ailleurs) : `soldElsewhere` — le propriétaire a CONFIRMÉ vendre à quelqu'un d'autre pendant qu'un acheteur
//   tient la réservation (soldElsewhereDialog) ; la base annule la réservation, prévient l'acheteur et rend la réservation
//   écrite (`reservation`). Sans lui, la même demande reste refusée (`reservation_held`). Un retrait déjà confirmé refuse
//   (`reservation_picked_up`). Envoyé seulement quand il est vrai : l'appel ordinaire reste celui du lot 3b.
const rpcSetListingStatus=(id,status,{soldElsewhere=false}={})=>lanacRpc({what:"statut d'annonce",name:"set_listing_status",idempotent:true,
  args:{p_listing_id:id,p_status:status,...(soldElsewhere?{p_sold_elsewhere:true}:{})},verify:d=>!!d&&d.status===status,
  quiet:["listing_closed","status_internal","status_not_offered","reservation_held","reservation_picked_up","listing_media_rejected"]});   // (R15, 27/10) un refus que l'écran sait dire
//  25/09/2026 (l'annonce part, suite) — « VENDU / LOUÉ / RÉALISÉ À CETTE PERSONNE », en UNE transaction (set_listing_sold_to) :
//   la même commande de statut (mêmes refus, même déclaration quand un autre tient la réservation), la personne nommée comme
//   gagnante pour la règle de la base (ses échanges se ferment avec SA raison, les autres « vendu à quelqu'un d'autre »), et son
//   accord « confirmé par le vendeur, en attente de l'acheteur » (`dealId`). NON idempotente : elle crée un accord, elle n'est
//   jamais rejouée — une coupure se dit, l'annonce se relit.
const rpcSetListingSoldTo=(id,status,buyerId,{soldElsewhere=false}={})=>lanacRpc({what:"vente à un acheteur nommé",name:"set_listing_sold_to",idempotent:false,
  args:{p_listing_id:id,p_status:status,p_buyer_id:buyerId,...(soldElsewhere?{p_sold_elsewhere:true}:{})},verify:d=>!!d&&d.status===status&&!!d.dealId,
  quiet:["listing_closed","status_internal","status_not_offered","reservation_held","reservation_picked_up","buyer_not_a_contact","buyer_holds_reservation","buyer_invalid","status_not_final"]});
//  ⭐ Lot C · R15b (27/10/2026) — L'ADMINISTRATION N'APPROUVE PAS UNE ANNONCE PAR SA COMMANDE (admin_reject_listing) : la seule voie (la base
//   n'exempte plus l'administration sur une annonce qu'un acheteur tient). `expectedBuyer` : l'acheteur que l'écran voit tenir la réservation (null
//   sinon) — la base le rejuge sous son verrou et refuse s'il a changé. OUI : {status:"rejected", changed, effect, strike, reservation} ; NON nommé
//   (admin_party, reservation_changed, listing_pickup_confirmed, listing_busy, admin_only, listing_not_found) que l'écran dit
//   (adminRejectRefusalKey). Idempotente : déjà refusée, rien ne change.
//   (relectures, 27/10) `expectedStatus` : l'état de cette réservation tel que l'écran l'a montré dans la confirmation — une demande acceptée entre-temps
//   poserait un carton que l'administration n'a pas confirmé : refusé (reservation_changed).
const rpcAdminRejectListing=(id,expectedBuyer=null,expectedStatus=null)=>lanacRpc({what:"refus d'annonce par l'administration",name:"admin_reject_listing",idempotent:true,
  args:{p_listing_id:id,p_expected_buyer:expectedBuyer||null,p_expected_status:expectedStatus||null},verify:d=>!!d&&d.status==="rejected",
  quiet:["admin_party","reservation_changed","listing_pickup_confirmed","listing_busy","admin_only","listing_not_found","listing_dossier_open"]});
//  ⭐ Lot C · R17 (28/10/2026) — LA FILE DES PHOTOS À VÉRIFIER (D-R15f-1, B-R15f-2) : un média jugé dur ou signalé pendant qu'un acheteur tenait l'annonce
//   ne l'a pas masquée ; l'administration la voit dans SA file (aucune notification) et la juge acceptable — ou la refuse par admin_reject_listing.
const rpcAdminMediaHolds=()=>lanacRpc({what:"photos à vérifier (administration)",name:"admin_media_holds",idempotent:true,args:{},
  verify:d=>Array.isArray(d),quiet:["admin_only"]});
//  vuA : l'heure du signal que la file a montrée (son « at ») — un signal plus récent remettra l'annonce en file
const rpcAdminMediaHoldOk=(id,vuA)=>lanacRpc({what:"photo jugée acceptable (administration)",name:"admin_media_hold_ok",idempotent:true,
  args:{p_listing_id:id,p_vu_a:vuA},verify:d=>!!d&&d.reviewed===true,quiet:["admin_only","media_hold_not_found","media_hold_seen_at_required"]});
const appBaseUrl=()=>{
  const path=window.location.pathname||"/";
  const clean=path.replace(/auth\/callback\/?$/,"").replace(/[^/]*$/,"");
  return `${window.location.origin}${clean}`;
};
const appEntryUrl=()=>`${appBaseUrl()}index.html`;
const authCallbackUrl=(flow="auth")=>`${appBaseUrl()}auth/callback/?lanac_auth_flow=${encodeURIComponent(flow)}`;
const oauthRedirectTo=()=>authCallbackUrl("oauth");
const oauthTermsKey=provider=>`lanac:oauthTerms:${provider}`;
const onboardingStateKey=id=>`lanac:onboarding:${id||"pending"}`;
const readOnboardingState=id=>{
  try{return JSON.parse(localStorage.getItem(onboardingStateKey(id))||"{}")||{};}catch{return{};}
};
const writeOnboardingState=(id,state)=>{
  try{localStorage.setItem(onboardingStateKey(id),JSON.stringify(state));}catch{}
  return state;
};
const mergeOnboardingState=(id,patch)=>writeOnboardingState(id,{...readOnboardingState(id),...patch,updatedAt:Date.now()});
const pendingSignupKey=email=>`lanac:pendingSignup:${(email||"").trim().toLowerCase()}`;
const savePendingSignupMeta=meta=>{
  if(!meta?.email) return;
  try{
    const safe={email:meta.email,name:meta.name||"",role:meta.role||"Particulier",acceptsOffers:!!meta.acceptsOffers,authUserId:meta.authUserId||null,authEmailSent:!!meta.authEmailSent,createdAt:meta.createdAt||Date.now()};
    localStorage.setItem(pendingSignupKey(meta.email),JSON.stringify(safe));
  }catch{}
};
const readPendingSignupMeta=email=>{
  try{return JSON.parse(localStorage.getItem(pendingSignupKey(email))||"null");}catch{return null;}
};
const clearPendingSignupMeta=email=>{try{localStorage.removeItem(pendingSignupKey(email));}catch{}};
const authUrlFlow=()=>{
  try{
    const url=new URL(window.location.href);
    return url.searchParams.get("lanac_auth_flow")||url.searchParams.get("type")||"";
  }catch{return"";}
};
const cleanAuthUrl=()=>{
  try{
    const url=new URL(window.location.href);
    ["lanac_auth_callback","lanac_auth_flow","type","code","state","error","error_code","error_description"].forEach(k=>url.searchParams.delete(k));
    url.hash="";
    window.history.replaceState({},document.title,url.pathname+(url.search||""));
  }catch{}
};
// FIX #2 (13/07) — Deep-link push « à froid ». Un clic sur un push OS app entièrement fermée
// ouvrait l'accueil (le SW faisait openWindow("./index.html") sans la cible). Le SW encode
// désormais la cible dans l'URL (?ln=1&v=…&c=…&it=…) ; on la capture au chargement, on nettoie
// l'URL aussitôt (un refresh ne rejoue pas), et l'app route vers le fil/l'annonce dès qu'elle est prête.
const readNotifDeepLink=()=>{
  try{
    const p=new URL(window.location.href).searchParams;
    if(p.get("ln")!=="1") return null;
    const t={};
    const v=p.get("v"); if(v) t.view=v;
    const c=p.get("c"); if(c) t.convoId=c;
    const it=p.get("it"); if(it) t.itemId=it;
    const al=p.get("al"); if(al&&/^[0-9a-f-]{36}$/i.test(al)) t.alertId=al;   // (04/10, A17) une notification d'alerte
    return (t.view||t.convoId||t.itemId||t.alertId)?t:null;
  }catch{return null;}
};
const cleanNotifDeepLink=()=>{
  try{
    const url=new URL(window.location.href);
    ["ln","v","c","it","al"].forEach(k=>url.searchParams.delete(k));
    window.history.replaceState({},document.title,url.pathname+(url.search||""));
  }catch{}
};
try{ window.__lanacNotifTarget=readNotifDeepLink(); if(window.__lanacNotifTarget) cleanNotifDeepLink(); }catch(_){}
const VIDEO_LIMITS={maxCount:1,maxDuration:20,maxSize:50*1024*1024};
const VIDEO_PURGE_DELAY=21*24*60*60*1000; // 3 semaines après clôture (vente/annulation) — visibilité des annonces vidéo au lancement
const VIDEO_PURGE_STATUSES=["sold","rented","cancelled","completed"];
const revokeMediaUrl=url=>{try{if(url&&String(url).startsWith("blob:"))URL.revokeObjectURL(url);}catch{}};
const listingVideoBucket=item=>item?.videoBucket||item?.videoMeta?.bucket||(window.LANAC_SUPABASE_VIDEO_BUCKET||localStorage.getItem("lanac:supabase:videoBucket")||"listing-videos");
const listingVideoPath=item=>item?.videoPath||item?.videoMeta?.path||item?.videoMeta?.storagePath||null;
const cleanupListingVideoAsset=item=>{
  revokeMediaUrl(item?.video||item?.videoUrl);
  const path=listingVideoPath(item);
  // Vidéo sur R2 → suppression via le Worker (vidéo + miniature)
  if(item?.videoBucket==="r2"||r2KeyFromUrl(item?.videoUrl)){
    const vKey=(path&&!/^(https?:|blob:|data:)/.test(path))?path:r2KeyFromUrl(item?.videoUrl);
    const tKey=r2KeyFromUrl(item?.videoThumb)||(vKey?vKey.replace(/\.[a-z0-9]+$/i,"_thumb.jpg"):null);
    if(vKey) deleteFromR2(vKey);
    if(tKey) deleteFromR2(tKey);
    return;
  }
  // Repli : ancien stockage Supabase
  const client=path&&lanacSupabaseClient();
  if(client) client.storage.from(listingVideoBucket(item)).remove([path]).catch(()=>{});
};
const purgeListingVideo=item=>({...item,video:null,videoUrl:null,videoPath:null,videoUploadedAt:null,videoBucket:null,videoThumb:null,videoMeta:null,videoPurgeAt:null,videoClosedAt:item.videoClosedAt||null});
const shouldPurgeVideoForStatus=status=>VIDEO_PURGE_STATUSES.includes(status);
const listingHasVideo=item=>!!(item?.video||item?.videoUrl||item?.videoPath);
const scheduleListingVideoPurge=(item,now=Date.now())=>shouldPurgeVideoForStatus(item?.status)&&listingHasVideo(item)
  ?{...item,videoClosedAt:item.videoClosedAt||now,videoPurgeAt:item.videoPurgeAt||now+VIDEO_PURGE_DELAY}
  :{...item,videoClosedAt:shouldPurgeVideoForStatus(item?.status)?item?.videoClosedAt||now:null,videoPurgeAt:shouldPurgeVideoForStatus(item?.status)?item?.videoPurgeAt||now+VIDEO_PURGE_DELAY:null};
const purgeListingVideoIfDue=(item,now=Date.now())=>listingHasVideo(item)&&shouldPurgeVideoForStatus(item.status)&&Number(item.videoPurgeAt||0)>0&&Number(item.videoPurgeAt)<=now
  ?purgeListingVideo(item)
  :item;
const terminalListingStatus=status=>["sold","rented","cancelled","completed","rejected"].includes(status);
const getVideoDuration=file=>new Promise((resolve,reject)=>{
  const url=URL.createObjectURL(file);
  const v=document.createElement("video");
  v.preload="metadata";
  v.onloadedmetadata=()=>{const d=v.duration;revokeMediaUrl(url);resolve(d);};
  v.onerror=()=>{revokeMediaUrl(url);reject(new Error("video_metadata"));};
  v.src=url;
});
const isVideoFile=file=>{
  const name=(file?.name||"").toLowerCase();
  return !!file&&(file.type?.startsWith("video/")||/\.(mp4|m4v|mov|webm|ogg)$/i.test(name));
};
const videoThumbnailFromUrl=url=>new Promise(resolve=>{
  const v=document.createElement("video");
  v.muted=true;v.playsInline=true;v.preload="metadata";
  let done=false;
  const finish=thumb=>{if(done)return;done=true;resolve(thumb||null);};
  const capture=()=>{
    try{
      const c=document.createElement("canvas");
      const maxW=720;
      const ratio=Math.min(1,maxW/(v.videoWidth||maxW));
      c.width=Math.max(1,Math.round((v.videoWidth||640)*ratio));
      c.height=Math.max(1,Math.round((v.videoHeight||360)*ratio));
      c.getContext("2d").drawImage(v,0,0,c.width,c.height);
      finish(c.toDataURL("image/jpeg",.78));
    }catch{finish(null);}
  };
  v.onloadedmetadata=()=>{
    try{
      const seek=Math.min(.4,Math.max(.05,(v.duration||1)/4));
      v.currentTime=Number.isFinite(seek)?seek:.1;
    }catch{capture();}
  };
  v.onseeked=capture;
  v.onloadeddata=()=>setTimeout(()=>!done&&capture(),80);
  v.onerror=()=>finish(null);
  v.src=url;
});
const prepareVideoFile=async file=>{
  const url=URL.createObjectURL(file);
  const thumb=await videoThumbnailFromUrl(url);
  return {url,thumb,file};
};


// ── TURNSTILE · preuve d'humanité pour les parcours d'AUTHENTIFICATION ───────
// POURQUOI : `email_exists` était un ORACLE D'ÉNUMÉRATION de comptes (on donne une
//   adresse, il répond oui/non, sans borne). On ne ferme pas ça en cachant la
//   réponse — l'existence fuit par 4 portes (inscription, erreur de connexion,
//   réinitialisation, temps de réponse). On la ferme en rendant la DEVINETTE CHÈRE.
//   Supabase Auth vérifie le jeton NATIVEMENT : aucun Worker à écrire.
//
// ⭐⭐ RÉTRO-COMPATIBLE PAR CONSTRUCTION — on renvoie `undefined` dès que quoi que ce
//   soit manque (script bloqué, réseau coupé, délai dépassé). Or `captchaToken:
//   undefined` est STRICTEMENT équivalent à « pas de captcha » côté Supabase. Ce code
//   est donc INERTE tant que la protection n'est pas activée au dashboard : c'est ce
//   qui permet de livrer le client AVANT la bascule, sans fenêtre de panne.
// ⭐ CHARGÉ À LA DEMANDE, jamais au démarrage : le chemin critique reste à zéro
//   blocage (chantier du 27/07). Le script n'arrive qu'au 1er geste d'authentification.
// ⚠️ `interaction-only` et NON le mode « Invisible » : même confort (un vrai visiteur
//   ne voit rien), SANS l'obligation de référencer l'avenant de confidentialité
//   Turnstile dans nos mentions légales — ce que le mode Invisible impose.
const TURNSTILE_SITEKEY="0x4AAAAAAEAv-ALFYkk6LDiq";  // PUBLIQUE par nature (elle vit dans le HTML)
const TURNSTILE_DELAI=8000;   // au-delà on rend la main SANS jeton, plutôt que de figer un bouton
let _tsScript=null,_tsWidget=null,_tsAttente=null;

const loadTurnstile=()=>{
  if(_tsScript)return _tsScript;
  _tsScript=new Promise(resolve=>{
    try{
      if(window.turnstile)return resolve(true);
      const s=document.createElement("script");
      s.src="https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
      s.defer=true;                    // jamais `async` — règle du dépôt
      s.onload=()=>resolve(true);
      s.onerror=()=>resolve(false);    // bloqueur, réseau coupé : on DÉGRADE, on ne casse pas
      document.head.appendChild(s);
    }catch(e){resolve(false);}
  });
  return _tsScript;
};

// Conteneur unique. Invisible tant qu'aucune interaction n'est requise ; centré en bas
// d'écran le jour où un défi s'affiche, pour qu'il soit effectivement VU.
const turnstileHost=()=>{
  let el=document.getElementById("lnc-turnstile");
  if(!el){
    el=document.createElement("div");
    el.id="lnc-turnstile";
    el.style.cssText="position:fixed;left:50%;transform:translateX(-50%);bottom:24px;z-index:2147483000;";
    document.body.appendChild(el);
  }
  return el;
};

// ⚠️ Le `callback` est enregistré UNE SEULE FOIS au `render`. Il ne peut donc pas
//   capturer le résolveur d'un appel particulier — sinon le 2e appel réveillerait la
//   promesse du 1er. On passe par un résolveur mutable, remis à null à chaque livraison.
const _tsLivrer=jeton=>{const r=_tsAttente;_tsAttente=null;if(r)r(jeton||undefined);};

// ⭐ Audit mobile 30/09/2026 (lot 2) : LE CADRE NE SURVIT PAS À LA DEMANDE. Quand Cloudflare montre le défi (réseau suspect,
//   navigation privée…), le conteneur restait posé pour toute la session, en position fixe au-dessus du dock — VU sur
//   l'accueil, la recherche et les résultats, connexion faite. Un jeton est à usage unique : le cadre l'est aussi. On retire
//   le widget ET son conteneur dès que la demande est servie (jeton, erreur ou délai) ; la demande suivante en recrée un.
const _tsRetirer=()=>{
  try{ if(_tsWidget!==null&&window.turnstile) window.turnstile.remove(_tsWidget); }catch(e){}
  _tsWidget=null;
  try{ const el=document.getElementById("lnc-turnstile"); if(el&&el.parentNode) el.parentNode.removeChild(el); }catch(e){}
};

// ⭐ Un jeton Turnstile est À USAGE UNIQUE : on `reset()` avant chaque demande.
const lncCaptchaToken=async()=>{
  try{
    if(!(await loadTurnstile()))return undefined;
    const ts=window.turnstile;
    if(!ts)return undefined;
    _tsLivrer(undefined);              // un appel concurrent ne reste jamais suspendu
    try{ return await new Promise(resolve=>{
      _tsAttente=resolve;
      const minuteur=setTimeout(()=>_tsLivrer(undefined),TURNSTILE_DELAI);
      const stop=()=>clearTimeout(minuteur);
      try{
        if(_tsWidget===null){
          _tsWidget=ts.render(turnstileHost(),{
            sitekey:TURNSTILE_SITEKEY,
            appearance:"interaction-only",
            execution:"execute",
            callback:j=>{stop();_tsLivrer(j);},
            "error-callback":()=>{stop();_tsLivrer(undefined);},
            "timeout-callback":()=>{stop();_tsLivrer(undefined);},
          });
        }else{ts.reset(_tsWidget);}
        ts.execute(_tsWidget);
      }catch(e){stop();_tsLivrer(undefined);}
    }); }finally{ _tsRetirer(); }
  }catch(e){return undefined;}
};

export { VIDEO_LIMITS, VIDEO_PURGE_DELAY, VIDEO_PURGE_STATUSES, appBaseUrl, appEntryUrl, authCallbackUrl, authUrlFlow, cleanAuthUrl, cleanNotifDeepLink, cleanupListingVideoAsset, clearPendingSignupMeta, ecrireCarte, getVideoDuration, isVideoFile, lanacCarteAuDemarrage, lanacEpoqueSession, lanacRpc, lanacUidRange, lanacSortie, oublierCarte, rpcAdminMediaHoldOk, rpcAdminMediaHolds, rpcAdminRejectListing, rpcSetListingSoldTo, rpcSetListingStatus, lanacSupabaseClient, lanacTropLong, lanacWrite, listingHasVideo, listingVideoBucket, listingVideoPath, lncCaptchaToken, mergeOnboardingState, oauthRedirectTo, oauthTermsKey, onboardingStateKey, pendingSignupKey, prepareVideoFile, purgeListingVideo, purgeListingVideoIfDue, readNotifDeepLink, readOnboardingState, readPendingSignupMeta, revokeMediaUrl, savePendingSignupMeta, scheduleListingVideoPurge, shouldPurgeVideoForStatus, supabaseConfig, terminalListingStatus, videoThumbnailFromUrl, writeOnboardingState };
